var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegistrationIconWalkIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.216,
    height: 20.002,
    viewBox: "0 0 21.216 20.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_535",
    "data-name": "Union 535",
    d: "M14930.967-17454a.9.9,0,0,1-.9-.9.9.9,0,0,1,.9-.9h2.741v-1.848h-5.657a4.042,4.042,0,0,1-2.863-1.184,4.051,4.051,0,0,1-1.188-2.863v-8.258a4.051,4.051,0,0,1,1.188-2.863,4.031,4.031,0,0,1,2.863-1.189h13.116a4.034,4.034,0,0,1,2.864,1.189,4.046,4.046,0,0,1,1.184,2.863v8.258a4.046,4.046,0,0,1-1.184,2.863,4.044,4.044,0,0,1-2.864,1.184h-5.661v1.848h2.745a.9.9,0,0,1,.9.9.9.9,0,0,1-.9.9Zm-4.508-17.541a2.247,2.247,0,0,0-.658,1.592v8.258a2.264,2.264,0,0,0,.658,1.592,2.25,2.25,0,0,0,1.592.658h13.116a2.254,2.254,0,0,0,1.593-.658,2.263,2.263,0,0,0,.657-1.592v-8.258a2.246,2.246,0,0,0-.657-1.592,2.257,2.257,0,0,0-1.593-.662h-13.116A2.253,2.253,0,0,0,14926.459-17471.541Zm6.477,8.6a1.771,1.771,0,0,1-.565-.381l-1.969-1.971a1,1,0,0,1,0-1.416,1,1,0,0,1,1.412,0l1.794,1.793,3.793-3.793a1,1,0,0,1,1.416,0,1,1,0,0,1,0,1.416l-3.969,3.971a1.736,1.736,0,0,1-.569.381,1.74,1.74,0,0,1-.671.131A1.777,1.777,0,0,1,14932.936-17462.945Z",
    transform: "translate(-14923.999 17474.002)",
    fill: "currentColor",
    opacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistrationIconWalkIn);
export default __webpack_public_path__ + "static/media/RegistrationIconWalkIn.ef602c254844fcf867d7fc06156b4e5f.svg";
export { ForwardRef as ReactComponent };